export default __webpack_public_path__ + "static/media/O-090.898a9617.png";